@use "../../sass/global/global" as *;

ux-iws-nb-content-header {
    display: block;
    overflow-x: hidden;

    h1,
    h2,
    h3 {
        margin: 0 0 10px;
        @include nb-heading(1, false);
    }

    [slot="text"],
    [slot="text"] p {
        color: #000;
    }
}

.ux-iws-nb-content-header__image {
    position: relative;
    overflow: hidden;
    aspect-ratio: 3 / 2;

    @media (min-width: 768px) {
        aspect-ratio: 4 / 1;
    }

    img,
    video,
    ux-video {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}

.ux-iws-nb-content-header__box {
    margin: 80px 0;
    box-sizing: border-box;
    max-width: 800px;

    @media (max-width: 567px) {
        padding: 0 15px;
    }

    @media (min-width: 568px) and (max-width: 767px) {
        padding: 0 30px;
    }
}
